import * as React from 'react';
import { TextField } from '@material-ui/core';
import { IObservableObject, IObservableValue } from 'mobx';
import { EmployeeDto, EmployeeRequest, Roles } from './userTypes';
import { observer } from 'mobx-react';
import { FormControlLabel } from '@material-ui/core';
import { FieldError } from '../../api/restApi';
import { translation } from '../../i18n';
import { createPicker } from '../../util/picker';
import { renderRemainingErrors, textFieldErrorProps } from '../../util/formUtils';
import { FormControl } from '@material-ui/core';
import { RadioGroup } from '@material-ui/core';
import { Radio } from '@material-ui/core';

interface Props {
  employee: EmployeeRequest & IObservableObject;
  /** The existing employee to be edited. Is undefined when creating a new one. */
  existingEmployee?: EmployeeDto;
  dirtyState: IObservableValue<boolean>;
  fieldErrors: FieldError[];
}

interface State {
  selectedRole: Roles
}

@observer
export class EmployeeForm extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedRole: Roles.USER
    };
  };

  public componentDidMount(): void {
    this.getUserRole();
  }

  public render() {
    const errorPicker = createPicker(this.props.fieldErrors);
    return (
      <>
        <TextField
          id="employeeForm_input_firstName"
          label={translation.t('employee.firstName')}
          margin="dense"
          fullWidth={true}
          value={this.props.employee.firstName}
          onChange={ev => {
            this.props.employee.firstName = ev.target.value;
            this.props.dirtyState.set(true);
          }}
          required={true}
          {...textFieldErrorProps(errorPicker.pick(e => e.field === 'firstName'))}
        />
        <TextField
          id="employeeForm_input_lastName"
          label={translation.t('employee.lastName')}
          margin="dense"
          fullWidth={true}
          value={this.props.employee.lastName}
          onChange={ev => {
            this.props.employee.lastName = ev.target.value;
            this.props.dirtyState.set(true);
          }}
          required={true}
          {...textFieldErrorProps(errorPicker.pick(e => e.field === 'lastName'))}
        />
        <TextField
          id="employeeForm_input_email"
          label={translation.t('employee.email')}
          margin="dense"
          fullWidth={true}
          value={this.props.employee.email}
          onChange={ev => {
            this.props.employee.email = ev.target.value;
            this.props.dirtyState.set(true);
          }}
          required={true}
          {...textFieldErrorProps(errorPicker.pick(e => e.field === 'email'))}
        />
        <FormControl>
          <RadioGroup
            aria-label="Gender"
            name="gender1"
            value={this.state.selectedRole}
            onChange={this.handleChange}
          >
            <FormControlLabel value={Roles.USER} control={<Radio/>} label={translation.t('userRoles.USER')}/>
            <FormControlLabel value={Roles.MAINTAINER} control={<Radio/>}
                              label={translation.t('userRoles.MAINTAINER')}/>
            <FormControlLabel value={Roles.ADMIN} control={<Radio/>} label={translation.t('userRoles.ADMIN')}/>
          </RadioGroup>
        </FormControl>
        {renderRemainingErrors(errorPicker.remaining())}
      </>
    )
  };

  private getUserRole = () => {
    if (this.props.existingEmployee == null) {
      this.setState({selectedRole: Roles.USER});
    } else {
      if (this.props.existingEmployee.roles.indexOf(Roles.USER) > -1) {
        this.setState({selectedRole: Roles.USER});
      }
      if (this.props.existingEmployee.roles.indexOf(Roles.MAINTAINER) > -1) {
        this.setState({selectedRole: Roles.MAINTAINER});
      }
      if (this.props.existingEmployee.roles.indexOf(Roles.ADMIN) > -1) {
        this.setState({selectedRole: Roles.ADMIN});
      }
    }
  };

  private handleChange = (event: any) => {
    const role = event.target.value;
    this.setState({selectedRole: role});
    this.addChangedRoles(role);
  };


  private addChangedRoles(role: Roles) {
    this.props.employee.roles = [];
    this.props.employee.roles.push(Roles.USER);
    if (role === Roles.MAINTAINER) {
      this.props.employee.roles.push(Roles.MAINTAINER);
    }
    if (role === Roles.ADMIN) {
      this.props.employee.roles.push(Roles.MAINTAINER);
      this.props.employee.roles.push(Roles.ADMIN);
    }
  }

}
